import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { DatePicker } from "antd";
import moment from "moment";

const RakProfileSectionOne = ({
  fromDate = null,
  setFromDate,
  toDate,
  setToDate,
  setModalShow,
  filtersSelected,
  noOfFiltersSelected,
  resetFilter,
  handleFIlter,
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  type="select"
                  style={{ height: "27px" }}
                  value={searchBy}
                  onChange={(e) => {
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                  className="inputFields"
                >
                  <option value="mobile">Mobile</option>
                  <option value="emiratesId">Emirates Id</option>

                  <option value="branchId">Branch ID</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  className="inputFields"
                  id="example3cols2Input"
                  style={{    height: "27px"}}
                  placeholder={searchByValuePlaceholder}
                  type="text"
                  onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
                  onChange={(e) =>
                    setSearchByValue(e.target.value && e.target.value.trim())
                  }
                  value={searchByValue}
                />
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  From
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setFromDate(moment(dateString, dateFormat));
                    } else {
                      setFromDate(null);
                    }
                  }}
                  value={fromDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  To
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setToDate(moment(dateString, dateFormat));
                    } else {
                      setToDate(null);
                    }
                  }}
                  value={toDate}
                />
              </FormGroup>
            </Col>
            <div
              lg="1"
              className="form-input-padding"
              style={{ marginTop: "2px" }}
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Filter by
                </Label>
                <div>
                  <Button
                    style={{ width: "100%", height: "26px" }}
                    color="primary"
                    type="button"
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => setModalShow(true)}
                  >
                    <div>
                      {" "}
                      <i className="fas fa-filter"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
              <span style={{ fontSize: 8 }}>
                {filtersSelected && noOfFiltersSelected > 0 ? (
                  <>
                    <h6 style={{ display: "flex", alignItems: "center" }}>
                      Selected({noOfFiltersSelected}){" "}
                      <i
                        class="fas fa-window-close"
                        onClick={() => resetFilter()}
                        style={{ cursor: "pointer", paddingLeft: "5px" }}
                      />
                    </h6>
                  </>
                ) : (
                  <></>
                )}
              </span>
            </div>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => handleFIlter(true)}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => resetFilter()}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default RakProfileSectionOne;
